import React, { Component } from 'react';
import AdvantegeGroup from './AdvantegeGroup';
import StepsGroup from './StepsGroup';
import PropTypes from 'prop-types';
import { Wrapper, Head, HeadConten,  HeadTitle, HeadText, Advanteges, AdvantegesContent, AdvantegesTitle, Steps } from './styled';

class MeetingPage extends Component {
    render() {
        const phone = this.props.phone;
        return (
            <Wrapper>
                <Head>
                    <HeadConten>
                        <HeadTitle>Как установить домофон Дом.ру в своем доме</HeadTitle>
                        <HeadText>Открывайте дверь подъезда, не отвлекаясь от дел. Смотрите, кто пришел, с видеокамеры домофона в приложении «Умный Дом.ru»</HeadText>
                    </HeadConten>
                </Head>
                <Advanteges>
                    <AdvantegesContent>
                        <AdvantegesTitle>Что вы получаете с «Умным домофоном»</AdvantegesTitle>
                        <AdvantegeGroup/>
                    </AdvantegesContent>
                </Advanteges>
                <Steps>
                    <StepsGroup phone = {phone}/>
                </Steps>
            </Wrapper>
        );
    }
}

export default MeetingPage;

MeetingPage.propTypes = {
    phone: PropTypes.string,
};
